export default __webpack_public_path__ + "static/media/chevron_right.13d953ac.svg";